module.exports = __webpack_public_path__ + "img/Headset Icon - white.35ed238a.svg";